import React from 'react';
import { Input, Table } from 'antd';
import { FilterOutlined } from '@ant-design/icons';

type Props = {
  height?: number;
  onSelectPo?: Function;
  poList: StringKAnyVPair[];
};

const PoListView = (props: Props) => {
  const columns = [
    {
      title: 'PO#',
      dataIndex: 'poNumber',
    },
    {
      title: 'PO Warehouse',
      dataIndex: 'warehouseCode',
    },
    {
      title: 'Supplier',
      dataIndex: 'vendorName',
    },
  ];

  const listRowProps = (record: StringKAnyVPair) => ({
    onClick: () => onRowClick(record),
  });

  const onRowClick = (record: StringKAnyVPair) => {
    //console.log('re', record);
    if (props.onSelectPo) props.onSelectPo(record);
  };

  const tableScrollHeight = () => {
    if (props.height) {
      const h = props.height - 92 - 20;

      return h > 0 ? h : 0;
    }
  };

  return (<div>
    <div style={{marginBottom: 12}}>
      <Input
        placeholder="Filter"
        prefix={<FilterOutlined />}
        size="large"
      />
    </div>
    <Table
      columns={columns}
      dataSource={props.poList}
      onRow={listRowProps}
      pagination={false}
      rowKey="poNum"
      scroll={{y: tableScrollHeight()}}
      size="middle"
    />
  </div>);
};

export default PoListView;
